import {getWorkspaceFromUri} from './getWorkspaceFromUri';

/**
 * Extra logic (displaying more data, etc.) used only in Cebia workspace.
 */
export function isCebiaWorkspace() {
  const workspaceInfo = getWorkspaceFromUri();

  return workspaceInfo.workspace === 'cebia';
}
